import ChangePassword from "../components/user/ChangePassword";

function Profile() {
  return (
    <div className="page p-1">
      <ChangePassword />
    </div>
  );
}

export default Profile;
